const STATUS_INCOMING = 1;
const STATUS_ACTIVE   = 2;
const STATUS_FINISHED = 3;

export class DailyQuest {
    static #statusesNameMap = {
        [STATUS_INCOMING] : 'incoming',
        [STATUS_ACTIVE] : 'active',
        [STATUS_FINISHED] : 'finished',
    };

    static isIncoming(status) {
        return status == STATUS_INCOMING;
    }

    static isActive(status) {
        return status == STATUS_ACTIVE;
    }

    static isFinished(status) {
        return status == STATUS_FINISHED;
    }

    static getStatusName(status) {
        return DailyQuest.#statusesNameMap[status];
    }

    static getStatus(record) {
        const now = Date.now();
        const startMs = record.stime * 1000;
        const endMs = (record.stime + record.duration) * 1000;

        if (now < startMs) {
            return STATUS_INCOMING;
        }
        if (now >= startMs && now < endMs) {
            return STATUS_ACTIVE;
        }
        return STATUS_FINISHED;
    }
}

export function isDailyQuestEditable(record) {
  const status = DailyQuest.getStatus(record);
  return (status === STATUS_INCOMING) || (status === STATUS_ACTIVE);
}
